import React from 'react';
import { dispatch } from '@rematch/core';
import { connect } from 'react-redux';
import TreeView from '@zippytech/react-toolkit/TreeView';
import '@zippytech/react-toolkit/TreeView/index.css';

class WsSettingTreeView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentStatus: null,
            currentPath: 0,
            collapsedDepth: 0
        }
    }

    nodeStyle = (nodeProps) => {
        if (this.props.selectedCategory && nodeProps.indexPath.substring(0,1) == 0 && nodeProps.indexPath.length > 1 && this.props.selectedCategory._id === nodeProps.node._id || this.props.selectedCategory == nodeProps.node.label) {
            return { color: '#7FC4FA', fontFamily: 'montserrat-semibold' }
        } else {
            if (this.state.currentPath === nodeProps.path) {
                return { color: '#7FC4FA', fontFamily: 'montserrat-semibold' }
            } else {
                return { color: '#6b6b6b', fontFamily: 'montserrat-normal', fontWeight: 'normal' }
            }
        }
    }

    async onSelectionChange(selectedMap) {
        // if (selectedMap.indexPath.substring(0,1) != 0 && this.state.currentPath !== selectedMap.path) {
        //     this.setState({ currentPath: selectedMap.path });
        //     dispatch.lifeCycle.setTreeCurrentPath(selectedMap.path);
        // }
        // else if(selectedMap.indexPath.substring(0,1) == 0 && this.state.currentPath !== selectedMap.path){
        //     this.setState({ currentPath: 0 });
        //     // dispatch.lifeCycle.setTreeCurrentPath(selectedMap.path);
        // }

        if (this.state.currentPath !== selectedMap.path) {
            this.setState({ currentPath: selectedMap.path });
            dispatch.lifeCycle.setTreeCurrentPath(selectedMap.path);
        }

        if (selectedMap.node && selectedMap.node.value === 'Knowledge Banks') {
            await dispatch.community.setMainAreaContext("baseCategory");
        } else if (selectedMap.node && selectedMap.node.baseCategory) {
            await dispatch.community.setMainAreaContext("category");
        } else if (selectedMap.node && selectedMap.node.category) {
            await dispatch.community.setMainAreaContext("subCategory");
        } else if (selectedMap.node && selectedMap.node.subCategory) {
            await dispatch.community.setMainAreaContext(null);
        } 
        // Below changes are made for KLM-8970
        else if (selectedMap.node && (selectedMap.node.value ==="Public Library" || selectedMap.node.value ==="General Settings")) {
            await dispatch.community.setMainAreaContext(null);
        } else if (selectedMap.node && selectedMap.node.value ==="Integrations") {
            await dispatch.community.setMainAreaContext(null);
        } else if (selectedMap.node && selectedMap.node.value ==="Metadata") {
            await dispatch.community.setMainAreaContext(null);
        }
        this.manageRoute(selectedMap);
    }

    manageRoute = async (selectedMap) => {
        let pathName;
        const history = this.props.history;

        let iPath = Number(selectedMap.indexPath.split('/')[0])
        await dispatch.account.setSelectedCategoryAsync(selectedMap.node);
        if (selectedMap.node.value === "Knowledge Banks") {
            dispatch.app.setCurrentContext("category");
            await dispatch.categories.getAllCategories({ organizationId: this.props.match.params.workspaceId });
            pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/categories`;
        } else if (iPath === 0 && selectedMap.depth === 1 || selectedMap.depth === 2) {
            dispatch.app.setCurrentContext("category");
            await dispatch.categories.getCategoryById(selectedMap.node._id);
            if (selectedMap.node.parent) {
                pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/categories/${selectedMap.node.parent}/${selectedMap.node._id}`;
            } else {
                pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/categories/${selectedMap.node._id}`;
            }

        } else if (iPath === 2 && selectedMap.depth === 0) {
            dispatch.app.setCurrentContext("category");
            await dispatch.community.setMainAreaContext(null);
            pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/integrations`;
        } else if (iPath === 2 && selectedMap.depth === 1) {
            dispatch.app.setCurrentContext("category");
            await dispatch.community.setMainAreaContext(null);
            let selectedNodeValue = selectedMap.node.id._id ? selectedMap.node.id._id : selectedMap.node.id
            dispatch.integrations.setSelectedIntegration(selectedNodeValue)
            pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/integrations/${selectedNodeValue}`;
        }
        // else if(iPath == 1 && selectedMap.node.value == 'Email Template'){
        //     pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/emailtemplates/${selectedMap.node.value}`;
        // }

        // else if (selectedMap.node.value == "Integrations") {
        //     dispatch.app.setCurrentContext("category");
        //     dispatch.integrations.setSelectedIntegration(selectedMap.node.value)
        //     pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/integrations/${selectedMap.node.value}`;
        // }
        else if (selectedMap.node.value == 'Email Template') {
            dispatch.app.setCurrentContext("wscustomtemplate");
            pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/emailTemplates/listing`;
        }
        else if (selectedMap.node.value == "Metadata") {
            await dispatch.community.setMainAreaContext(null);
            pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/metaData`  // Added for Workspace metadata KLM-8948
        }
        else if (selectedMap.node.value == 'Public Library') {
            // dispatch.app.setCurrentContext("wscustomtemplate");
            await dispatch.community.setMainAreaContext(null);
            pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/generalSetting/publicLibrary`;
        }else if (selectedMap.node.value == 'Login Access') {
            await dispatch.community.setMainAreaContext(null);
            pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/generalSetting/loginAccess`;
        }
        else if (selectedMap.node.value == 'General Settings') {
            // dispatch.app.setCurrentContext("wscustomtemplate");
            await dispatch.community.setMainAreaContext(null);
            pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/generalSetting/listing`;
        }

        history.push({
            pathname: pathName
        });
    }

    componentWillMount() {
        dispatch.lifeCycle.getCategoryTreeAsync({ accountId: this.props.match.params.accountId });
        dispatch.lifeCycle.getPublicCategoryTreeAsync();
        let pathName = `/app/${this.props.routeParams.accountId}/_ws/${this.props.routeParams.workspaceId}/_wsSetting/`;
        if(pathName+"categories"==this.props.location.pathname){
          this.setState({ currentPath: "0" })
        }else if(pathName+"emailTemplates/listing"==this.props.location.pathname){
          this.setState({ currentPath: "1" })
        }else if(pathName+"integrations"==this.props.location.pathname){
          this.setState({ currentPath: "2" })
        }else if(pathName+"generalSetting/listing"==this.props.location.pathname){
          this.setState({ currentPath: "3" })
        }else if(pathName+"metaData"==this.props.location.pathname){
            this.setState({ currentPath: "4" })
          }
    }

    render() {

        const { categoryTree } = this.props;
      
        let intList = this.props.selectedAccount && this.props.selectedAccount.integrations && this.props.selectedAccount.integrations.length !== 0 && this.props.selectedAccount.integrations.filter(
            (item) => item.isActive
        );
        if (
            this.props.integrationsList &&
            this.props.integrationsList.data &&
            this.props.integrationsList.data.length > 0 &&
            intList &&
            intList.length > 0
        ) {
            for (let i = 0; i < this.props.integrationsList.data.length; i++) {
                let compareString;
                for (let j = 0; j < intList.length; j++) {
                    compareString = intList[j].id._id ? intList[j].id._id : intList[j].id
                    if (
                        compareString === this.props.integrationsList.data[i]._id
                    ) {
                        intList[j].label = this.props.integrationsList.data[i].label;
                        break;
                    }
                }
            }
        }
        // if (intList && intList.length > 0) {
        //     intList = intList.map((m, i) => {
        //         m.label = m.id.label
        //         m.value = m.id._id ? m.id._id : m.id
        //         return m
        //     })
        // }
        const treeList = [
            {
                label: "Knowledge Banks",
                name: "Knowledge Banks",
                value: "Knowledge Banks",
                id: 2,
                nodes: this.props.categoryTree
            }
            ,
            {
                label: "Email Template",
                value: "Email Template",
                id: 4
            },
            {
                label: "Integrations",
                name: "Integrations",
                value: "Integrations",
                id: 3,
                nodes: intList
            },

        ];
            treeList.push(
                {
                    label: "General Settings",
                    name: "General Settings",
                    value: "General Settings",
                    id: 5,
                    nodes: [{
                        label:"Public Library",
                        name: "Public Library",
                        value: "Public Library",
                    },
                    {
                        label:"Login Access",
                        name: "Login Access",
                        value: "Login Access",
                    }]
                },
                {
                    label: "Metadata",
                    name: "Metadata",
                    value: "Metadata",
                    id: 6,
                },
            )
        // this.props.selectedAccount &&
        //     this.props.selectedAccount.integrations &&
        //     this.props.selectedAccount.integrations.length !== 0 &&
        //     treeList.push({
        //         label: "Integrations",
        //         name: "Integrations",
        //         value: "Integrations",
        //         id: 3,
        //         nodes: intList
        //     })

        return (
            <div>
                <TreeView
                    leafNodeIcon={
                        <svg fill="#000000" height="16" viewBox="0 0 24 24" width="22" style={{ verticalAlign: 'middle', overflow: 'inherit' }}>
                            <path d="M 0 10 20 10" stroke="#F6F6F6" strokeWidth="1" fill="none" />
                        </svg>
                    }
                    className="browserPane tree-ellipsis"
                    enableSelection={true}
                    nodeStyle={this.nodeStyle}
                    onSelectionChange={(selectedMap) => { this.onSelectionChange(selectedMap) }}
                    dataSource={treeList}
                    singleSelect={true}
                    collapsedDepth={this.state.collapsedDepth}
                    onCollapsedDepthChange={() => this.setState({ collapsedDepth: null })}
                    enableHoverStyle={false}
                    enableKeyboardNavigation={false}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {

    };
}

const wsSettingView = connect(mapStateToProps)(WsSettingTreeView);

export default wsSettingView;